/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerificationDto } from '../../models/verification-dto';

export interface ApiPasswordresetVerifyPasswordResetLinkPost$Params {
  'api-version'?: string;
      body?: VerificationDto
}

export function apiPasswordresetVerifyPasswordResetLinkPost(http: HttpClient, rootUrl: string, params?: ApiPasswordresetVerifyPasswordResetLinkPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiPasswordresetVerifyPasswordResetLinkPost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiPasswordresetVerifyPasswordResetLinkPost.PATH = '/api/passwordreset/verify-password-reset-link';
